import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './stores';
import { globalVar } from './globalVar';
import './assets/tailwind.css';
import 'animate.css';
import './assets/css/animate.css';

// PrimeVue
import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura';
import 'primeicons/primeicons.css'
import { ConfirmationService, ToastService } from 'primevue';
import Tooltip from 'primevue/tooltip';
import { definePreset } from '@primevue/themes';

const app = createApp(App);
app.config.globalProperties.$globalVar = globalVar;
app.directive('tooltip', Tooltip);
app.use(store);
app.use(router);
app.use(ConfirmationService);
app.use(ToastService);

// Initialize dark mode on app start
store.dispatch('darkMode/initDarkMode');

const MyPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '#ffffff',
            100: '#f2e6e8',
            200: '#e6cdd1',
            300: '#d9b4b9',
            400: '#cc9ba1',
            500: '#800020',
            600: '#6b001b',
            700: '#560015',
            800: '#400010',
            900: '#2b000a',
            950: '#1a0007'
        }
    }
});


app.use(PrimeVue, {
    theme: {
        preset: MyPreset,
        options: {
            prefix: 'p',
            darkModeSelector: false || 'none',
            cssLayer: false
        }
    }
});
app.mount('#app');